/** 0 = leeres Feld, 1..9 = gesetzte Ziffer. Immer genau 81 Einträge. */
export type Grid = Uint8Array;

/** Kandidaten-Bitmaske: Bit (n-1) gesetzt => Ziffer n ist noch möglich. */
export type Candidates = Uint16Array;

export type Difficulty = 'easy' | 'medium' | 'hard' | 'expert';

export const DIFFICULTIES: readonly Difficulty[] = ['easy', 'medium', 'hard', 'expert'];

export interface Puzzle {
  /** Das Rätsel mit Lücken. */
  puzzle: Grid;
  /** Die (eindeutige) Lösung. */
  solution: Grid;
  /** Tatsächlich erreichter Schwierigkeitsgrad. */
  difficulty: Difficulty;
  /** Anzahl vorgegebener Ziffern. */
  clues: number;
  /** Seed, mit dem das Rätsel reproduzierbar ist. */
  seed: number;
}

export const ALL_CANDIDATES = 0b111111111;

export function bit(digit: number): number {
  return 1 << (digit - 1);
}

/** Anzahl gesetzter Bits (Kandidatenzahl). */
export function popcount(mask: number): number {
  let n = 0;
  while (mask) {
    mask &= mask - 1;
    n++;
  }
  return n;
}

/** Ziffer der niedrigsten gesetzten Bitposition (1..9), 0 bei leerer Maske. */
export function lowestDigit(mask: number): number {
  return mask === 0 ? 0 : 32 - Math.clz32(mask & -mask);
}

/** Alle Ziffern einer Maske als Array. */
export function digitsOf(mask: number): number[] {
  const out: number[] = [];
  for (let d = 1; d <= 9; d++) if (mask & bit(d)) out.push(d);
  return out;
}
